import React from 'react';
import GenericModalForm from '../GenericModalForm';
import ar from './ar.json';
import en from './en.json';
import { LocaleContext } from '../../../../contexts/language';
import { IntlProvider } from 'react-intl';
import BasicEnquiryFormFields from '../../../atoms/BasicEnquiryFormFields';
import PropTypes from 'prop-types';

const languages = {
  ar,
  en
};


export const ZeroDepositModalForm = ({ ...rest }) => {

  const localeConfig = React.useContext(LocaleContext);

  return (
    <IntlProvider locale={localeConfig?.lang} messages={languages[localeConfig?.lang] || languages.en}>
      <GenericModalForm
        {...rest}
        defaultValues={{
          firstName: '',
          lastName: '',
          message: 'Are you able to offer zero deposit with this vehicle?',
          emailAddress: '',
          phoneNumber: '',
        }}
        // editTitle={'Edit Person'}
        addTitle={'Send an Enquiry'}
        editTitle={'Send an Enquiry'}
        onSubmitText={'Send Enquiry'}
        onSubmitTitle={'Ask a question'}
        onNewSnackText={'Enquiry Sent successfully'}
        onEditSnackText={'Enquiry Sent successfully'}>
        {({ loading }) => (
          <>
            <BasicEnquiryFormFields loading={loading} />
          </>
        )}
      </GenericModalForm>
    </IntlProvider>
  );
};

ZeroDepositModalForm.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};
ZeroDepositModalForm.defaultProps = {
  onClose: () => {
  },
  open: false
};

export default ZeroDepositModalForm;